import { Component, OnInit, Input, HostBinding, ViewChild, ElementRef, HostListener } from '@angular/core';
import { IUProperty } from 'src/app/shared/interface/umbraco-property';
import { IPictureData } from '../../shared/components/picture/picture.component';

interface IUserGuidePanelData {
  title?: IUProperty<string>;
  subtitle?: IUProperty<string>;
  backgroundImage?: IUProperty<IPictureData>;
  items?: any;
  panelSettings?: any;
  waves?: IUProperty<string[]>;
}

@Component({
  selector: 'app-user-guide-panel',
  templateUrl: './user-guide-panel.component.html',
  styleUrls: ['./user-guide-panel.component.less']
})
export class UserGuidePanelComponent implements OnInit {
  @Input() data: IUserGuidePanelData;
  @ViewChild('panelElRef', { static: false }) panelElRef: ElementRef<HTMLElement>;
  items: any[] = [];
  scrollPosition: number = null;

  @HostListener('window:scroll', []) onWindowScroll() {
    this.scrollPosition = window.pageYOffset;
    if ((this.scrollPosition + window.outerHeight) > this.panelElRef.nativeElement.offsetTop) {
      this.loadMedia();
    }
  }

  ngOnInit() {
    if (this.data && this.data.items && this.data.items.value) {
      this.items = this.data.items.value;
    }
  }

  ngAfterViewInit(): void {
    if (this.data && this.data.waves && this.data.waves.value && this.panelElRef && this.panelElRef.nativeElement) {
      this.panelElRef.nativeElement.style.paddingTop = this.data.waves.value[0] ? '115px' : '45px';
      this.panelElRef.nativeElement.style.paddingBottom = this.data.waves.value[1] ? '115px' : '45px';
    }

    if ((this.scrollPosition + window.outerHeight) > this.panelElRef.nativeElement.offsetTop) {
      this.loadMedia();
    }
  }

  loadMedia() {
    if (this.data && this.data.backgroundImage && this.data.backgroundImage.value && this.panelElRef && this.panelElRef.nativeElement) {
      this.panelElRef.nativeElement.style.backgroundImage = 'url(' + this.data.backgroundImage.value.src + ')';
      this.panelElRef.nativeElement.style.backgroundSize = 'cover';
      this.panelElRef.nativeElement.style.backgroundRepeat = 'no-repeat';
    }
  }

}

